
import Loader from "@/components/loader/Loader.vue";
import Scrollbar from "@/components/scrollbar/Scrollbar.vue";
import { clickOutside } from "@/directives/clickOutside";
import { debounce } from "@/lib/debounce";
import Component from "vue-class-component";
import { Model, Prop, Vue } from "vue-property-decorator";
import Input from "@/components/input/Input.vue";
import DropdownContainer from "./parts/DropdownContainer.vue";
import DropdownItem from "./parts/DropdownItem.vue";
import DropdownItems from "./parts/DropdownItems.vue";

type Value = string | number;
type Item = { label: string; value: Value };

@Component({
  components: {
    Scrollbar,
    Loader,
    DropdownItem,
    DropdownItems,
    BaseInput: Input,
    DropdownContainer
  },
  directives: {
    clickOutside
  }
})
export default class Dropdown extends Vue {
  @Prop({ required: true }) label!: string;
  @Prop({ default: "" }) error!: string;
  @Prop({ default: false }) multiple!: boolean;
  @Prop({ default: "" }) defaultValue!: string;
  @Prop({ required: true }) onSearch!: (value: string) => Promise<Item[]>;
  @Model("change", { required: false, type: [String, Number] }) value!:
    | Value
    | undefined;

  isOpen = false;
  isLoading = true;
  searchValue = "";
  searchError = "";
  items: Item[] = [];

  mounted() {
    this.search('');

  }

  close() {
    this.isOpen = false;
    this.$emit('toggle', false)
  }

  open(){
    this.isOpen = true;
    this.$emit('toggle', true);
  }

  get inputValue() {
    if (!this.value) {
      return this.searchValue;
    }
    const item = this.items.find(item => item.value === this.value);
    if (!item) {
      return "";
    }
    return item.label;
  }

  onSelect(value: Value) {
    this.$emit("change", value);
    if (!this.multiple) this.close();
  }

  onInput(value: string) {

    this.$emit("change", "");
    this.searchValue = value;

    if (value){

      this.open();
      this.debouncedSearch(value);

    } else {

      this.close();
    }

  }

  private debouncedSearch = debounce(this.search, 500);

  private async search(value: string) {
    this.isLoading = true;
    this.searchError = "";
    try {
      this.items = await this.onSearch(value);
    } catch (error) {
      this.searchError = "search-error";
    } finally {
      this.isLoading = false;
    }
  }
}
